<router-outlet></router-outlet>
<p-confirmDialog
  key="invoi-confirmation-dialog"
  id="invoi-confirmation-dialog"
  icon="pi pi-exclamation-triangle"
></p-confirmDialog>
<p-toast position="top-center" />
